export function getOptionLabel(
  options: Array<{ value: string; label: string }>,
  value: string
) {
  return options.find((option) => option.value === value)?.label ?? value;
}

const EARTH_RADIUS_KM = 6371;

/** Beyond this, distance-from-user is noise while browsing a different map area. */
export const NEARBY_DISTANCE_DISPLAY_KM = 150;

const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

/** Great-circle distance between two lat/lng points, in kilometres. */
export function haversineDistanceKm(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) {
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) ** 2;
  return EARTH_RADIUS_KM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/** Compact distance label; returns null when the job is far from the user. */
export function formatNearbyDistanceKm(km: number): string | null {
  if (km > NEARBY_DISTANCE_DISPLAY_KM) {
    return null;
  }
  if (km < 1) {
    return "Under 1 km";
  }
  if (km < 10) {
    return `${km.toFixed(1)} km`;
  }
  return `${Math.round(km)} km`;
}

/** Soften ALL-CAPS store names for list readability without inventing branding. */
export function formatListingPlaceName(name: string) {
  const letters = name.replace(/[^a-zA-Z]/g, "");
  if (letters.length < 4) {
    return name;
  }
  const upperRatio =
    letters.replace(/[^A-Z]/g, "").length / Math.max(letters.length, 1);
  if (upperRatio < 0.7) {
    return name;
  }
  return name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
}
